/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Patients.Web.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  AuthTokenApiContract,
  AuthTokenPairApiContract,
  AuthTokenPairPatientApiContract,
  CheckEmailUniqueInContract,
  EmailApiContract,
  ErrorDescription,
  MagicLinkLoginWebApiInContract,
  PasswordLoginWebApiInContract,
  RegisterPatientApiOutContract,
  RegisterPatientWebApiInContract,
  TokenApiContract,
  TokenWithPasswordApiContract
} from '../pwrdbyQuickMDPatientsWebApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * # Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | AccountLocked | Account is locked, wait before trying again |
| 400 | CredentialsNotValid | Invalid auth credentialss |
| 400 | PasswordDetectedInBreach | Password detected in breach and must be changed |
| 400 | EmailNotValid | Invalid email format |
| 400 | PasswordResetRequired | Password must be reset before logging in |
 * @summary Email/Password login
 */
export const postAuthLoginV2 = (
    passwordLoginWebApiInContract: PasswordLoginWebApiInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<AuthTokenPairPatientApiContract>(
      {url: `https://patient-web-api.api.quick.md/api/v2/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: passwordLoginWebApiInContract, signal
    },
      options);
    }
  


export const getPostAuthLoginV2MutationOptions = <TError = ErrorDescription,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthLoginV2>>, TError,{data: PasswordLoginWebApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthLoginV2>>, TError,{data: PasswordLoginWebApiInContract}, TContext> => {

const mutationKey = ['postAuthLoginV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthLoginV2>>, {data: PasswordLoginWebApiInContract}> = (props) => {
          const {data} = props ?? {};

          return  postAuthLoginV2(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthLoginV2MutationResult = NonNullable<Awaited<ReturnType<typeof postAuthLoginV2>>>
    export type PostAuthLoginV2MutationBody = PasswordLoginWebApiInContract
    export type PostAuthLoginV2MutationError = ErrorDescription

    /**
 * @summary Email/Password login
 */
export const usePostAuthLoginV2 = <TError = ErrorDescription,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthLoginV2>>, TError,{data: PasswordLoginWebApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthLoginV2>>,
        TError,
        {data: PasswordLoginWebApiInContract},
        TContext
      > => {

      const mutationOptions = getPostAuthLoginV2MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * | HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | EmailNotValid | Email is invalid |
 * @summary Request Magic Link Email
 */
export const postAuthMagiclinkRequestV2 = (
    emailApiContract: EmailApiContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://patient-web-api.api.quick.md/api/v2/auth/magiclink/request`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: emailApiContract, signal
    },
      options);
    }
  


export const getPostAuthMagiclinkRequestV2MutationOptions = <TError = ErrorDescription,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthMagiclinkRequestV2>>, TError,{data: EmailApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthMagiclinkRequestV2>>, TError,{data: EmailApiContract}, TContext> => {

const mutationKey = ['postAuthMagiclinkRequestV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthMagiclinkRequestV2>>, {data: EmailApiContract}> = (props) => {
          const {data} = props ?? {};

          return  postAuthMagiclinkRequestV2(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthMagiclinkRequestV2MutationResult = NonNullable<Awaited<ReturnType<typeof postAuthMagiclinkRequestV2>>>
    export type PostAuthMagiclinkRequestV2MutationBody = EmailApiContract
    export type PostAuthMagiclinkRequestV2MutationError = ErrorDescription

    /**
 * @summary Request Magic Link Email
 */
export const usePostAuthMagiclinkRequestV2 = <TError = ErrorDescription,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthMagiclinkRequestV2>>, TError,{data: EmailApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthMagiclinkRequestV2>>,
        TError,
        {data: EmailApiContract},
        TContext
      > => {

      const mutationOptions = getPostAuthMagiclinkRequestV2MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Login using magic link is an alternative to the standard login with email and password.
            
# Error Codes
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | TokenNotValid | Invalid token |
| 400 | AccountNotVerified | Account not verified by user yet |
| 400 | AccountNotActive | Account is not active |
| 500 | InternalServerError | Internal server error |
 * @summary Magic Link Login
 */
export const postAuthMagiclinkLoginV2 = (
    magicLinkLoginWebApiInContract: MagicLinkLoginWebApiInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<AuthTokenPairPatientApiContract>(
      {url: `https://patient-web-api.api.quick.md/api/v2/auth/magiclink/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: magicLinkLoginWebApiInContract, signal
    },
      options);
    }
  


export const getPostAuthMagiclinkLoginV2MutationOptions = <TError = ErrorDescription,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthMagiclinkLoginV2>>, TError,{data: MagicLinkLoginWebApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthMagiclinkLoginV2>>, TError,{data: MagicLinkLoginWebApiInContract}, TContext> => {

const mutationKey = ['postAuthMagiclinkLoginV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthMagiclinkLoginV2>>, {data: MagicLinkLoginWebApiInContract}> = (props) => {
          const {data} = props ?? {};

          return  postAuthMagiclinkLoginV2(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthMagiclinkLoginV2MutationResult = NonNullable<Awaited<ReturnType<typeof postAuthMagiclinkLoginV2>>>
    export type PostAuthMagiclinkLoginV2MutationBody = MagicLinkLoginWebApiInContract
    export type PostAuthMagiclinkLoginV2MutationError = ErrorDescription

    /**
 * @summary Magic Link Login
 */
export const usePostAuthMagiclinkLoginV2 = <TError = ErrorDescription,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthMagiclinkLoginV2>>, TError,{data: MagicLinkLoginWebApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthMagiclinkLoginV2>>,
        TError,
        {data: MagicLinkLoginWebApiInContract},
        TContext
      > => {

      const mutationOptions = getPostAuthMagiclinkLoginV2MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * # Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | TokenNotValid | Invalid token |
| 429 | TooManyRequests | Too many requests, wait before trying again |
 * @summary Exchange auth token for a new one.
 */
export const postAuthRefreshtokenV2 = (
    authTokenApiContract: AuthTokenApiContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<AuthTokenPairApiContract>(
      {url: `https://patient-web-api.api.quick.md/api/v2/auth/refreshtoken`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authTokenApiContract, signal
    },
      options);
    }
  


export const getPostAuthRefreshtokenV2MutationOptions = <TError = ErrorDescription,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthRefreshtokenV2>>, TError,{data: AuthTokenApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthRefreshtokenV2>>, TError,{data: AuthTokenApiContract}, TContext> => {

const mutationKey = ['postAuthRefreshtokenV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthRefreshtokenV2>>, {data: AuthTokenApiContract}> = (props) => {
          const {data} = props ?? {};

          return  postAuthRefreshtokenV2(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthRefreshtokenV2MutationResult = NonNullable<Awaited<ReturnType<typeof postAuthRefreshtokenV2>>>
    export type PostAuthRefreshtokenV2MutationBody = AuthTokenApiContract
    export type PostAuthRefreshtokenV2MutationError = ErrorDescription

    /**
 * @summary Exchange auth token for a new one.
 */
export const usePostAuthRefreshtokenV2 = <TError = ErrorDescription,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthRefreshtokenV2>>, TError,{data: AuthTokenApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthRefreshtokenV2>>,
        TError,
        {data: AuthTokenApiContract},
        TContext
      > => {

      const mutationOptions = getPostAuthRefreshtokenV2MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Check if the email is valid and unique.
 */
export const postAuthCheckemailuniqueV2 = (
    checkEmailUniqueInContract: CheckEmailUniqueInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://patient-web-api.api.quick.md/api/v2/auth/checkemailunique`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: checkEmailUniqueInContract, signal
    },
      options);
    }
  


export const getPostAuthCheckemailuniqueV2MutationOptions = <TError = ErrorDescription,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthCheckemailuniqueV2>>, TError,{data: CheckEmailUniqueInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthCheckemailuniqueV2>>, TError,{data: CheckEmailUniqueInContract}, TContext> => {

const mutationKey = ['postAuthCheckemailuniqueV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthCheckemailuniqueV2>>, {data: CheckEmailUniqueInContract}> = (props) => {
          const {data} = props ?? {};

          return  postAuthCheckemailuniqueV2(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthCheckemailuniqueV2MutationResult = NonNullable<Awaited<ReturnType<typeof postAuthCheckemailuniqueV2>>>
    export type PostAuthCheckemailuniqueV2MutationBody = CheckEmailUniqueInContract
    export type PostAuthCheckemailuniqueV2MutationError = ErrorDescription

    /**
 * @summary Check if the email is valid and unique.
 */
export const usePostAuthCheckemailuniqueV2 = <TError = ErrorDescription,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthCheckemailuniqueV2>>, TError,{data: CheckEmailUniqueInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthCheckemailuniqueV2>>,
        TError,
        {data: CheckEmailUniqueInContract},
        TContext
      > => {

      const mutationOptions = getPostAuthCheckemailuniqueV2MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * # Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | EmailNotUnique | Email is already in use |
| 400 | PasswordDetectedInBreach | Password detected in breach and must be changed |
| 400 | EmailNotValid | Invalid email format |
| 429 | TooManyRequests | Too many requests, wait before trying again |
| 400 | EmailUndeliverable | Email undeliverable/bounced |
| 400 | PasswordNotValid | Password does not meet complexity requirements |
| 400 | ThirdPartyError | Error on third party side. See info in Data object |
| 400 | PasswordNotValid | Password is not valid |
| 400 | FirstNameNotValid| FirstName is not valid |
| 400 | LastNameNotValid | LastName is not valid |
| 422 | PhoneNumberNotValid | PhoneNumber is not valid |
| 400 | BirthDateNotValid| BirthDate is not valid |
| 400 | TokenNotValid | Phone number verification token is not valid |
| 400 | GenderNotValid| Gender is not valid |
| 400 | AddressNotValid| Address entered is not valid |
 * @summary Register a new patient account.
 */
export const postAuthRegisterV2 = (
    registerPatientWebApiInContract: RegisterPatientWebApiInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<RegisterPatientApiOutContract>(
      {url: `https://patient-web-api.api.quick.md/api/v2/auth/register`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerPatientWebApiInContract, signal
    },
      options);
    }
  


export const getPostAuthRegisterV2MutationOptions = <TError = ErrorDescription,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthRegisterV2>>, TError,{data: RegisterPatientWebApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthRegisterV2>>, TError,{data: RegisterPatientWebApiInContract}, TContext> => {

const mutationKey = ['postAuthRegisterV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthRegisterV2>>, {data: RegisterPatientWebApiInContract}> = (props) => {
          const {data} = props ?? {};

          return  postAuthRegisterV2(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthRegisterV2MutationResult = NonNullable<Awaited<ReturnType<typeof postAuthRegisterV2>>>
    export type PostAuthRegisterV2MutationBody = RegisterPatientWebApiInContract
    export type PostAuthRegisterV2MutationError = ErrorDescription

    /**
 * @summary Register a new patient account.
 */
export const usePostAuthRegisterV2 = <TError = ErrorDescription,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthRegisterV2>>, TError,{data: RegisterPatientWebApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthRegisterV2>>,
        TError,
        {data: RegisterPatientWebApiInContract},
        TContext
      > => {

      const mutationOptions = getPostAuthRegisterV2MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * # Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | TokenNotValid | Invalid token |
| 429 | TooManyRequests | Too many requests, wait before trying again |
 * @summary Verify email address.
 */
export const postAuthVerifyemailV2 = (
    tokenApiContract: TokenApiContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<EmailApiContract>(
      {url: `https://patient-web-api.api.quick.md/api/v2/auth/verifyemail`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tokenApiContract, signal
    },
      options);
    }
  


export const getPostAuthVerifyemailV2MutationOptions = <TError = ErrorDescription,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthVerifyemailV2>>, TError,{data: TokenApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthVerifyemailV2>>, TError,{data: TokenApiContract}, TContext> => {

const mutationKey = ['postAuthVerifyemailV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthVerifyemailV2>>, {data: TokenApiContract}> = (props) => {
          const {data} = props ?? {};

          return  postAuthVerifyemailV2(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthVerifyemailV2MutationResult = NonNullable<Awaited<ReturnType<typeof postAuthVerifyemailV2>>>
    export type PostAuthVerifyemailV2MutationBody = TokenApiContract
    export type PostAuthVerifyemailV2MutationError = ErrorDescription

    /**
 * @summary Verify email address.
 */
export const usePostAuthVerifyemailV2 = <TError = ErrorDescription,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthVerifyemailV2>>, TError,{data: TokenApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthVerifyemailV2>>,
        TError,
        {data: TokenApiContract},
        TContext
      > => {

      const mutationOptions = getPostAuthVerifyemailV2MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * # Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | EmailNotValid | Invalid email format |
| 400 | EmailUndeliverable | Email undeliverable/bounced |
| 400 | AccountLocked | Account locked temporarily, wait before trying again |
 * @summary Request new verification email
 */
export const postAuthResendverificationemailV2 = (
    emailApiContract: EmailApiContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://patient-web-api.api.quick.md/api/v2/auth/resendverificationemail`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: emailApiContract, signal
    },
      options);
    }
  


export const getPostAuthResendverificationemailV2MutationOptions = <TError = ErrorDescription,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthResendverificationemailV2>>, TError,{data: EmailApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthResendverificationemailV2>>, TError,{data: EmailApiContract}, TContext> => {

const mutationKey = ['postAuthResendverificationemailV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthResendverificationemailV2>>, {data: EmailApiContract}> = (props) => {
          const {data} = props ?? {};

          return  postAuthResendverificationemailV2(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthResendverificationemailV2MutationResult = NonNullable<Awaited<ReturnType<typeof postAuthResendverificationemailV2>>>
    export type PostAuthResendverificationemailV2MutationBody = EmailApiContract
    export type PostAuthResendverificationemailV2MutationError = ErrorDescription

    /**
 * @summary Request new verification email
 */
export const usePostAuthResendverificationemailV2 = <TError = ErrorDescription,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthResendverificationemailV2>>, TError,{data: EmailApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthResendverificationemailV2>>,
        TError,
        {data: EmailApiContract},
        TContext
      > => {

      const mutationOptions = getPostAuthResendverificationemailV2MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @deprecated
 */
export const putAuthValidateresetpasswordtokenV2 = (
    tokenApiContract: TokenApiContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://patient-web-api.api.quick.md/api/v2/auth/validateresetpasswordtoken`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: tokenApiContract
    },
      options);
    }
  


export const getPutAuthValidateresetpasswordtokenV2MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAuthValidateresetpasswordtokenV2>>, TError,{data: TokenApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putAuthValidateresetpasswordtokenV2>>, TError,{data: TokenApiContract}, TContext> => {

const mutationKey = ['putAuthValidateresetpasswordtokenV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAuthValidateresetpasswordtokenV2>>, {data: TokenApiContract}> = (props) => {
          const {data} = props ?? {};

          return  putAuthValidateresetpasswordtokenV2(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAuthValidateresetpasswordtokenV2MutationResult = NonNullable<Awaited<ReturnType<typeof putAuthValidateresetpasswordtokenV2>>>
    export type PutAuthValidateresetpasswordtokenV2MutationBody = TokenApiContract
    export type PutAuthValidateresetpasswordtokenV2MutationError = unknown

    /**
 * @deprecated
 */
export const usePutAuthValidateresetpasswordtokenV2 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAuthValidateresetpasswordtokenV2>>, TError,{data: TokenApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAuthValidateresetpasswordtokenV2>>,
        TError,
        {data: TokenApiContract},
        TContext
      > => {

      const mutationOptions = getPutAuthValidateresetpasswordtokenV2MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * # Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | AccountLocked | Account locked temporarily, wait before trying again |
| 400 | EmailNotValid | Invalid email format |
| 400 | EmailUndeliverable | Email undeliverable/bounced |
 * @summary Send forgot password email
 */
export const postAuthForgotpasswordV2 = (
    emailApiContract: EmailApiContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://patient-web-api.api.quick.md/api/v2/auth/forgotpassword`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: emailApiContract, signal
    },
      options);
    }
  


export const getPostAuthForgotpasswordV2MutationOptions = <TError = ErrorDescription,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthForgotpasswordV2>>, TError,{data: EmailApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthForgotpasswordV2>>, TError,{data: EmailApiContract}, TContext> => {

const mutationKey = ['postAuthForgotpasswordV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthForgotpasswordV2>>, {data: EmailApiContract}> = (props) => {
          const {data} = props ?? {};

          return  postAuthForgotpasswordV2(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthForgotpasswordV2MutationResult = NonNullable<Awaited<ReturnType<typeof postAuthForgotpasswordV2>>>
    export type PostAuthForgotpasswordV2MutationBody = EmailApiContract
    export type PostAuthForgotpasswordV2MutationError = ErrorDescription

    /**
 * @summary Send forgot password email
 */
export const usePostAuthForgotpasswordV2 = <TError = ErrorDescription,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthForgotpasswordV2>>, TError,{data: EmailApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthForgotpasswordV2>>,
        TError,
        {data: EmailApiContract},
        TContext
      > => {

      const mutationOptions = getPostAuthForgotpasswordV2MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * # Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | PasswordDetectedInBreach | Password detected in breach and must be changed |
| 400 | TokenNotValid | Invalid token |
| 429 | TooManyRequests | Too many requests, wait before trying again |
| 400 | PasswordNotValid | Password does not meet complexity requirements |
 * @summary Reset password
 */
export const putAuthResetpasswordV2 = (
    tokenWithPasswordApiContract: TokenWithPasswordApiContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://patient-web-api.api.quick.md/api/v2/auth/resetpassword`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: tokenWithPasswordApiContract
    },
      options);
    }
  


export const getPutAuthResetpasswordV2MutationOptions = <TError = ErrorDescription,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAuthResetpasswordV2>>, TError,{data: TokenWithPasswordApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putAuthResetpasswordV2>>, TError,{data: TokenWithPasswordApiContract}, TContext> => {

const mutationKey = ['putAuthResetpasswordV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAuthResetpasswordV2>>, {data: TokenWithPasswordApiContract}> = (props) => {
          const {data} = props ?? {};

          return  putAuthResetpasswordV2(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAuthResetpasswordV2MutationResult = NonNullable<Awaited<ReturnType<typeof putAuthResetpasswordV2>>>
    export type PutAuthResetpasswordV2MutationBody = TokenWithPasswordApiContract
    export type PutAuthResetpasswordV2MutationError = ErrorDescription

    /**
 * @summary Reset password
 */
export const usePutAuthResetpasswordV2 = <TError = ErrorDescription,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAuthResetpasswordV2>>, TError,{data: TokenWithPasswordApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAuthResetpasswordV2>>,
        TError,
        {data: TokenWithPasswordApiContract},
        TContext
      > => {

      const mutationOptions = getPutAuthResetpasswordV2MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    